
<div 
    class="element-render-moveable-dnd"
    [id]="'element-render-moveable-dnd-'+ element.entryId"
    [class.has-frame]="element.hasFrame"
    [class.is-dragging]="isDragging"
    role="group"
    [attr.aria-label]="getResponseLabel()"
    [style.width.em]="element.width"
    [style.height.em]="element.height"
 data-ui-name="Get Response Label()" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-get-response-label">
    <p *ngIf="!isLocked" class="sr-only" [id]="getInstructionsId()">{{ getInstructions() }}</p>
    <p class="sr-only" role="status" aria-live="polite" aria-atomic="true" data-ui-name="Live Message" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-live-message">{{ liveMessage }}</p>
    <render-image 
        class="render-image"
        *ngIf="element.backgroundImg" 
        [element]="element.backgroundImg"
        [ngStyle]="getImageStyle()"
     data-ui-name="Render image" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-render-image"></render-image>
    <div class="background-el" [class.override-no-ptr-events]="allowBgImagePtrEvents()">
        <div *ngFor="let image of this.element.moveableImages">
            <div *ngIf="image" (click)="checkWholeHighlightIfType(image)" data-ui-name="Div" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-div">
              <element-render class="moveable-obj" [style.left.em]="image.x" [style.top.em]="image.y" [contentElement]="image" [ngStyle]="getImageStyle()" [questionPubSub]="questionPubSub" data-ui-name="Element render" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-element-render"></element-render>
            </div>
        </div>
    </div>
    <div  cdkDropListGroup>
        <div *ngFor="let target of this.targets;let cind=index" [attr.tabindex]="isLocked ? null : 0" (keyup.enter)="onEnter($event,target,cind)"
            (keydown.space)="$event.preventDefault()" (keyup.space)="onEnter($event,target,cind)"
            cdkDropList
            [cdkDropListDisabled]="isLocked"
            class="target-el"
            [cdkDropListData]="target.contents"
            cdkDropListSortingDisabled
            (cdkDropListDropped)="drop($event); isDragging=false"
            (cdkDropListEntered)="isDragging = !isLocked"
            (mousedown)="onClickToDrag($event, target, cind)"
            role="button"
            [attr.aria-label]="getTargetAccessibleLabel(target)"
            [attr.aria-pressed]="isSelected(target)"
            [attr.aria-disabled]="isLocked ? 'true' : null"
            [attr.aria-describedby]="!isLocked ? getInstructionsId() : null"
            [ngStyle]="target.targetContext ? getTargetStyle(target) : {}"
            [class.is-selected-edit]="editSelection.isSelectedEdit(target.targetContext, questionPubSub)"
            [style.border]="getBorderEditSelect(target)"
         data-ui-name="Div" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-div-6de43be">
            <div class="hover-indicator"></div>
            <div cdkDrag class="drag-el" [class.is-deactivateDropShadow]="element.isHideDraggableDropShadow" [cdkDragDisabled]="isLocked" 
                (cdkDragStarted) = "dragStarted($event)"                
                (cdkDragMoved) = "dragging($event)"
                [class.is-transparent]="element.isDragsTransparent" 
                [style.width.em]="element.isDraggableNotResizable ? '' : target.targetContext.width" 
                [style.height.em]="element.isDraggableNotResizable ? '' : target.targetContext.height"
                [style.padding.em]="target.targetContext.padding ? target.targetContext.padding : target.contents[0].ref.padding"
                [style.background-color]="getDraggableColour(target.contents[0].ref)"
                *ngIf="target.contents && target.contents[0] && target.contents[0].ref && target.contents[0].ref.element"
                (mousedown)="clickDrag(target.contents[0].ref); onClickToDrag($event, target, cind)"
                (click)="checkWholeHighlightIfType(target.contents[0].ref.element)"
             data-ui-name="Div" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-div-d45ea52">
                <element-render 
                    [class.is-selected]="isSelected(target)"
                    [class.is-para-full-width]="element.isParaFullWidth"
                    [contentElement]="target.contents[0].ref.element"
                    [questionPubSub]="questionPubSub"
                 data-ui-name="Element render" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-element-render-element-render"></element-render>
                <div class="img-drag-shield"></div>
                <render-audio 
                   *ngIf="target.contents[0].ref.voiceover && target.contents[0].ref.voiceover.url"
                  [url]="target.contents[0].ref.voiceover.url" 
                  [trigger]="getClickTrigger(target.contents[0].ref)" 
                  [isTriggerDisabled]="!isVoiceOverEnabled()"
                 data-ui-name="Render audio" data-ui-component="element-render-moveable-dnd" data-testid="element-render-moveable-dnd-render-audio"></render-audio>
            </div>
        </div>
    </div>
</div>
